import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { MonthviewStyle } from './monthview.style';
import { ILocalEvent } from '@app-types/websocket/event.types';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import { IFamilyMember } from '@app-types/websocket/family.types';

const tn: TranslateNew = TranslateNew.getInstance();
const BG_OPACITY = "d6";

interface IProps extends WithStyles<typeof MonthviewStyle> {
  shape:React.CSSProperties; // width, margin and corners from the row layout
  hide?:boolean;
  event:IExternalCalenderEvent;
  family:IFamilyMember[];
  style?:React.CSSProperties;
  userId:number;
}

interface IState {
  someValue: number;
}

class DayExternalEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      someValue: 1,
    };

  }

  public render() {
    const {classes, shape, event} = this.props;
    let background:string = "#c3c3c3"+BG_OPACITY;

    if (event.tagged){
      const tag = this.props.family.find((mem) => mem.id === event.tagged);
      if (tag) {
        background = tag.color+BG_OPACITY;
      }
    }

    let opacity:number = 1;

    if (this.props.hide) {
      opacity = 0;
    }

    const finalStyle:React.CSSProperties= { ...this.props.style, background, ...shape, opacity };
    if (event.tagged && event.tagged === this.props.userId) {
      finalStyle.fontWeight = 600;
    }
    return (
      <div className={classes.event} style={finalStyle}>
        {event.title}
      </div>
    );
  }


}

export default withStyles(MonthviewStyle)(DayExternalEvent);



// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/DayExternalEvent.tsx